// Import Dependencies
import React from 'react';

import { SALES_PHONE_NUMBER_FORMATTED } from '~/common/utils/consts';

// Import Stylesheet
import styles from './fatalErrorModal.css';
import btnStyles from '../CommonButton/common-button.css';


const FatalErrorModal = () => {
    return (
        <div className={styles.fatalErrorModal} id="fatal-modal">
            <h1 className={styles.header}>
                Yikes! There's been a problem...
            </h1>
            <p className={styles.content}>
                If you continue to experience this error, please contact our 24/7 Support at {SALES_PHONE_NUMBER_FORMATTED}.
            </p>
            <a
                className={`${btnStyles.button} ${styles.refreshButton}`} href="/"
                id="fatal-modal__reaload"
            >
                Try Again
            </a>
        </div>
    );
};

export default FatalErrorModal;
